// extracted by mini-css-extract-plugin
export default {"mainContainer":"PortfolioSpace_mainContainer__0oYut"};